/**
 * Adzuki.Ajax
 */

(function Ajax($, Adzuki)
{
	"use strict";

	var ajax = {};

	// core ajax method
	function _ajax(opts)
	{
		opts.url = Adzuki.get_url(opts.url);
		return $.ajax(opts);
	}

	// "get" shim
	ajax.get = function get(url)
	{
		return _ajax({
			type: 'get',
			url : url,
		});
	};

	// "post" shim
	ajax.post = function post(url, data, content_type)
	{
		var opts = {
			type: 'post',
			url : url,
			data: data,
		};

		if (typeof content_type !== 'undefined') {
			opts.contentType = content_type;
		}

		return _ajax(opts);
	};


	// this global binding is like a hook for us to view any and all ajax
	// responses received system-wide, in order to do a session expiration check
	// https://api.jquery.com/Ajax_Events/ to see the order of ajax events
	$(document).ajaxSuccess(function NSA_hook(event, xhr, settings)
	{
		var json;

		try
		{
			json = $.parseJSON(xhr.responseText);

			if (json.status && json.status === 'session_expired') {
				window.location.href = json.redirect_url;
			}
		}
		catch (err) {
			// session expiration notices will always be json
		}
	});

	$(document).ajaxError(function NSA_hook(event, xhr, settings, thrownError)
	{
		if (thrownError !== 'abort') {
			Adzuki.MobileApp.ajaxFailed();
		}
	});

	Adzuki.Ajax = ajax;
}(jQuery, window.Adzuki || {}));